<template>
    <span>{{danwei}}{{getNum}}</span>
</template>

<script>
export default {
    props: {
        startNum:{
            type:Number,
            default:0
        },
        toNum:{
            type:Number,
            default:1
        },
        duration:{
            type:Number,
            default:3
        },
        danwei:{
            type:String,
            default:``
        },
    },
    data(){
        return {
            num:0,
            t1 : null,
            runDt : 20 // 間隔時間 ms
        }
    },
    computed:{
        getNum(){
            return Math.floor(this.num).toLocaleString()
        }
    },
    mounted(){
        // this.startCount();  
    },
    methods:{
        startCount(){
            const dis = (this.toNum - this.startNum) / (this.duration*(1000/this.runDt));
            const toBigger = dis > 0;

            this.num = this.startNum;
            this.t1 = setInterval(() => {
                this.num += dis;
                
                if(toBigger && this.num >= this.toNum) {
                    this.num = this.toNum;
                    clearInterval(this.t1);
                } else if(!toBigger && this.num < this.toNum) {
                    this.num = this.toNum;
                    clearInterval(this.t1);
                }
            }, this.runDt);
        }
    }
}
</script>

<style lang="less" scoped>

</style>
